/**
 * Single source of truth for RunCode language configuration.
 *
 * Every UI that shows a language selector (CodeEditor, CodeInline, useCodeStore)
 * MUST import from here. Do NOT hardcode language values anywhere else.
 *
 * The `value` fields must match the backend CodeLang Java enum names exactly:
 *   - NodeJS_16  (runs Node.js 20 on AWS Lambda)
 *   - Python_3_9 (runs Python 3.12 on AWS Lambda)
 *
 * The enum names are frozen for backward compatibility with stored data.
 * Only the labels and actual runtimes change when AWS Lambda versions are upgraded.
 */

export const CODE_LANG = {
  PYTHON: {
    value: 'Python_3_9',
    label: 'Python 3.12',
    aceName: 'python',
    nameIncludes: 'Python',
  },
  NODE: {
    value: 'NodeJS_16',
    label: 'Node.js 20',
    aceName: 'javascript',
    nameIncludes: 'NodeJS',
  },
};

export const CODE_LANG_DEFAULT = CODE_LANG.PYTHON.value;

export const CODE_LANG_OPTIONS = [
  { value: CODE_LANG.PYTHON.value, label: CODE_LANG.PYTHON.label },
  { value: CODE_LANG.NODE.value, label: CODE_LANG.NODE.label },
];

export function aceNameForLang(langValue) {
  if (langValue && langValue.includes(CODE_LANG.NODE.nameIncludes)) {
    return CODE_LANG.NODE.aceName;
  }
  return CODE_LANG.PYTHON.aceName;
}

// Legacy export kept for any remaining consumers
export const LANGUAGES = {
  PYTHON: {
    NAME: CODE_LANG.PYTHON.nameIncludes,
    ACE_NAME: CODE_LANG.PYTHON.aceName,
  },
  JAVASCRIPT: {
    NAME: CODE_LANG.NODE.nameIncludes,
    ACE_NAME: CODE_LANG.NODE.aceName,
  },
};

export const FREE_USER_TIERS = ['FREE', 'FREE_TRIAL'];
